export const AGENT_DETAIL_PAGE = 'reports/detail/AGENT_DETAIL_PAGE'
export const TEAM_DETAIL_PAGE = 'reports/detail/TEAM_DETAIL_PAGE'
